import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { ExportPinOptionsModel } from "../models/GroupedOptionsModel";

@Injectable({ providedIn: "root" })

export class ExportPicturesService {
  constructor(private http: HttpClient) { }

  exportPictures(contractId: number): Observable<any> {
    return this.http.get<any>(`${environment.api}/api/PDF/${contractId}`);
  }

  exportPinOptions(model: ExportPinOptionsModel[]) {
    return this.http.post<any>(`${environment.api}/api/PDF/exportPinnedOptions`, model);
  }
}
